module.exports = __webpack_public_path__ + "static/media/MHRM82N0001.12fba609.svg";